import type { Requisition } from '../types';

// Relocated to the shared constants layer; re-exported for within-feature callers.
export { requisitionStatusConfig } from '@/constants/requisition-constants';

export interface TypeConfig {
  label: string;
}

export const requisitionTypeConfig: Record<
  Requisition['requisition_type'],
  TypeConfig
> = {
  new_hire: {
    label: 'New hire',
  },
  backfill: {
    label: 'Backfill',
  },
  internal: {
    label: 'Internal',
  },
};
